import { FC } from 'react';

import { PlatformForm as Form } from '@/shared/components/forms';

import OAuthApplicationScopeSelector from '../OAuthApplicationScopeSelector';

const OAuthScopesSection: FC = () => (
    <Form.Item
        name='scopes'
        rules={[
            {
                validator: (_rule, value?: string[]) =>
                    value?.length ? Promise.resolve() : Promise.reject(new Error('Select at least one OAuth scope')),
            },
        ]}
    >
        <OAuthApplicationScopeSelector />
    </Form.Item>
);

export default OAuthScopesSection;
